// in src/posts.js
import React, { Component } from 'react';
import {BooleanField, ImageField, ImageInput, DeleteButton, BooleanInput, ShowButton, DateField, RichTextField, Show, SimpleShowLayout, SimpleList, Filter, List, Edit, Create, Datagrid, ReferenceField, TextField, EditButton, ReferenceInput, required, SelectInput, SimpleForm, TextInput } from 'react-admin';
import Dropzone from 'react-dropzone'
import inputUploadField from '../mui/field/UploadField';
import InputUploadInput from '../mui/field/UploadInput';
import { RichTextInput } from 'ra-input-rich-text';
import onDrop from '../mui/field/onDrop';
import { useMediaQuery } from '@mui/material';

//Utils
import Validators from './renderFields/validatorsFields';

const NewFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Buscar" source="name" alwaysOn />
    </Filter>
);

export const NewList = (props) => {
    // Check if the screen size is small
    const isSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'));

    return (
        <List {...props} title="Listar Noticias" filters={<NewFilter />}>
            {isSmall ? (
                <SimpleList
                    primaryText={record => record.name}
                    tertiaryText={record => new Date(record.createdAt).toLocaleDateString()}
                />
            ) : (
                <Datagrid>
                    <TextField source="id" />
                    <TextField source="name" label="Título" />
                    <TextField source="summary" label="Resumen" />
                    <ImageField source="cover" label="Portada" />
                    <BooleanField source="state" label="Estado" />
                    <EditButton />
                    <ShowButton />
                    <DeleteButton />
                </Datagrid>
            )}
        </List>
    );
};

const NewName = ({ record }) => {
    return <span>Noticia {record ? `"${record.name}"` : ''}</span>;
};

export const NewEdit = (props) => (
    <Edit title={<NewName />} {...props}>
        <SimpleForm>
            <TextInput source="id" disabled/>
            <TextInput source="name" label="Título" validate={[Validators.required]}/>
            <InputUploadInput source="cover" label="Portada" validate={[Validators.required]}/>
            <TextInput source="summary" label="Resumen" validate={[Validators.required]} multiline/>
            <RichTextInput source="body" label="Contenido" isRequired={true} validation={{ required: true }}/>
            <TextInput source="url" />
            <BooleanInput label="Estado" source="state" />
        </SimpleForm>
    </Edit>
);

export const NewCreate = (props) => (
    <Create {...props} title="Crear Noticia">
        <SimpleForm >
            <TextInput source="name" label="Título" validate={[Validators.required]}/>
            <InputUploadInput source="cover" label="Portada" validate={[Validators.required]}/>
            <TextInput source="summary" label="Resumen" validate={[Validators.required]} miltiline/>
            <RichTextInput source="body" label="Contenido" isRequired={true} validation={{ required: true }}/>
            <TextInput source="url" required={false}/>
            <BooleanInput label="Estado" source="state" defaultValue={true} />
        </SimpleForm>
    </Create>
);

export const NewShow = (props) => (
    <Show title={<NewName />} {...props}>
        <SimpleShowLayout>
            <TextField source="name" label="Título"/>
            <RichTextField source="summary" label="Resumen"/>
            <RichTextField source="body" label="Contenido"/>
            <ImageField source="cover" label="Portada"/>
            <TextField source="url" />
            <BooleanField source="state" label="Estado"/>
            <DateField label="Fecha de Actualización" source="updatedAt" />
            <DateField label="Fecha de Publicación" source="createdAt" />
        </SimpleShowLayout>
    </Show>
);
